import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http"; 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class AddDonateService {

  constructor(private http: HttpClient) {}

  async donate(data) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      };
      let response = await this.http
        .post(`${appApiResources.addDonate}`, data, httpOptions)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }
 
}
